(() => {
  const doc = document;
  const body = doc.body;
  const currencyCode =
    doc.documentElement.getAttribute('data-cart-currency') ||
    window.Shopify?.currency?.active ||
    'EUR';

  const escapeHtml = (value) =>
    String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

  const formatMoney = (cents, currency = currencyCode) => {
    try {
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: currency || 'EUR'
      }).format((Number(cents) || 0) / 100);
    } catch (_error) {
      return `€${((Number(cents) || 0) / 100).toFixed(2).replace('.', ',')}`;
    }
  };

  const updateBodyLock = () => {
    const hasOpenDrawer = !!doc.querySelector('.prepnord-cart.is-open');
    body.classList.toggle('menu-open', hasOpenDrawer);
  };

  const closeMenus = () => {
    doc.querySelectorAll('[data-prepnord-mobile-collections][open]').forEach((menu) => {
      menu.open = false;
    });

    updateBodyLock();
  };

  const mobileCollectionsMenus = Array.from(
    doc.querySelectorAll('[data-prepnord-mobile-collections]')
  );

  mobileCollectionsMenus.forEach((menu) => {
    menu.addEventListener('toggle', () => {
      if (!menu.open) return;

      mobileCollectionsMenus.forEach((otherMenu) => {
        if (otherMenu !== menu) {
          otherMenu.open = false;
        }
      });
    });
  });

  doc.addEventListener('click', (event) => {
    mobileCollectionsMenus.forEach((menu) => {
      if (menu.open && !menu.contains(event.target)) {
        menu.open = false;
      }
    });
  });

  const drawers = Array.from(doc.querySelectorAll('[data-prepnord-cart-drawer]'));
  let cartCache = null;
  let cartPending = null;

  const setCountBadges = (count) => {
    doc.querySelectorAll('[data-prepnord-cart-count]').forEach((badge) => {
      badge.textContent = count;
      badge.hidden = count < 1;
    });
  };

  const setLoading = (drawer) => {
    const bodyElement = drawer.querySelector('[data-prepnord-cart-body]');
    if (!bodyElement) return;
    bodyElement.innerHTML = '<p class="prepnord-copy">Winkelwagen wordt geladen...</p>';
  };

  const renderCartIntoDrawer = (drawer, cart) => {
    const bodyElement = drawer.querySelector('[data-prepnord-cart-body]');
    const subtotalElement = drawer.querySelector('[data-prepnord-cart-subtotal]');
    const emptyHref = drawer.getAttribute('data-empty-href') || '/collections/all';

    if (!bodyElement || !subtotalElement) return;

    subtotalElement.textContent = formatMoney(cart.total_price, cart.currency || currencyCode);

    if (!cart.items || cart.items.length === 0) {
      bodyElement.innerHTML = `
        <div class="prepnord-cart__empty">
          <div>
            <p>Je winkelwagen is leeg</p>
            <p>Voeg een item toe om verder te gaan.</p>
            <a class="prepnord-button" href="${escapeHtml(emptyHref)}">Bekijk collectie</a>
          </div>
        </div>
      `;
      return;
    }

    bodyElement.innerHTML = cart.items
      .map((item, index) => {
        const variant =
          item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="prepnord-cart__item-variant">${escapeHtml(item.variant_title)}</p>`
            : '';
        const image = item.image
          ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}">`
          : '';

        return `
          <article class="prepnord-cart__item">
            <a class="prepnord-cart__item-image" href="${escapeHtml(item.url)}">${image}</a>
            <div>
              <div class="prepnord-cart__item-line">
                <div>
                  <a class="prepnord-cart__item-title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
                  ${variant}
                </div>
                <strong class="prepnord-cart__item-price">${formatMoney(item.final_line_price, cart.currency || currencyCode)}</strong>
              </div>
              <div class="prepnord-cart__qty">
                <button type="button" data-prepnord-cart-change data-line="${index + 1}" data-quantity="${Math.max(item.quantity - 1, 0)}">−</button>
                <span>${item.quantity}</span>
                <button type="button" data-prepnord-cart-change data-line="${index + 1}" data-quantity="${item.quantity + 1}">+</button>
                <button type="button" data-prepnord-cart-change data-line="${index + 1}" data-quantity="0">×</button>
              </div>
            </div>
          </article>
        `;
      })
      .join('');
  };

  const renderCartEverywhere = (cart) => {
    cartCache = cart;
    setCountBadges(cart.item_count || 0);
    drawers.forEach((drawer) => renderCartIntoDrawer(drawer, cart));
  };

  const fetchCart = async ({ force = false } = {}) => {
    if (!force && cartCache) return cartCache;
    if (cartPending) return cartPending;

    cartPending = fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then((response) => {
        if (!response.ok) throw new Error('Kon winkelwagen niet laden');
        return response.json();
      })
      .then((cart) => {
        renderCartEverywhere(cart);
        return cart;
      })
      .finally(() => {
        cartPending = null;
      });

    return cartPending;
  };

  const closeDrawers = () => {
    drawers.forEach((drawer) => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    });
    updateBodyLock();
  };

  const openDrawer = async (uid) => {
    const drawer =
      doc.querySelector(`[data-prepnord-cart-drawer="${uid}"]`) ||
      drawers[0];

    if (!drawer) return;

    closeMenus();
    closeDrawers();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    setLoading(drawer);
    updateBodyLock();

    try {
      await fetchCart({ force: true });
    } catch (_error) {
      const bodyElement = drawer.querySelector('[data-prepnord-cart-body]');
      if (bodyElement) {
        bodyElement.innerHTML = '<p class="prepnord-copy">Er ging iets mis bij het laden van je winkelwagen.</p>';
      }
    }
  };

  doc.querySelectorAll('[data-prepnord-cart-open]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      openDrawer(button.getAttribute('data-prepnord-cart-open'));
    });
  });

  doc.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-prepnord-cart-close]');
    if (closeButton) {
      closeDrawers();
      return;
    }

    const overlay = event.target.closest('.prepnord-cart__overlay');
    if (overlay) {
      closeDrawers();
      return;
    }

    const quantityButton = event.target.closest('[data-prepnord-cart-change]');
    if (!quantityButton) return;

    const line = Number(quantityButton.getAttribute('data-line'));
    const quantity = Number(quantityButton.getAttribute('data-quantity'));
    if (line < 1 || quantity < 0) return;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ line, quantity })
    })
      .then((response) => {
        if (!response.ok) throw new Error('Kon winkelwagen niet wijzigen');
        return response.json();
      })
      .then((cart) => {
        renderCartEverywhere(cart);
      })
      .catch(() => {
        const openDrawerElement = doc.querySelector('.prepnord-cart.is-open [data-prepnord-cart-body]');
        if (openDrawerElement) {
          openDrawerElement.insertAdjacentHTML(
            'afterbegin',
            '<p class="prepnord-copy">Aanpassen van de winkelwagen is mislukt.</p>'
          );
        }
      });
  });

  doc.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-prepnord-add-to-cart]');
    if (!form) return;

    event.preventDefault();

    const submitButton = form.querySelector('[type="submit"]');
    const targetUid = form.getAttribute('data-prepnord-cart-target');
    const formData = new FormData(form);
    const errorSlot = form.querySelector('[data-prepnord-form-error]');

    if (errorSlot) {
      errorSlot.hidden = true;
    }

    if (submitButton) {
      submitButton.disabled = true;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: new URLSearchParams(formData)
    })
      .then((response) => {
        if (!response.ok) throw new Error('Kon product niet toevoegen');
        return response.json();
      })
      .then(() => fetchCart({ force: true }))
      .then(() => openDrawer(targetUid))
      .catch(() => {
        if (errorSlot) {
          errorSlot.hidden = false;
        }
      })
      .finally(() => {
        if (submitButton) {
          submitButton.disabled = false;
        }
      });
  });

  const activateThumb = (root, thumb) => {
    if (!thumb) return;

    const mainImage = root.querySelector('[data-prepnord-main-image]');
    if (!mainImage) return;

    const src = thumb.getAttribute('data-src');
    const alt = thumb.getAttribute('data-alt');
    const mediaId = thumb.getAttribute('data-media-id');

    if (src) {
      mainImage.setAttribute('src', src);
    }
    if (alt) {
      mainImage.setAttribute('alt', alt);
    }

    root.querySelectorAll('[data-prepnord-thumb]').forEach((button) => {
      button.classList.toggle('is-active', button === thumb);
    });

    if (mediaId) {
      mainImage.setAttribute('data-media-id', mediaId);
    }
  };

  doc.querySelectorAll('[data-prepnord-product]').forEach((root) => {
    const variantSelect = root.querySelector('[data-prepnord-variant-select]');
    const priceElement = root.querySelector('[data-prepnord-price]');
    const compareElement = root.querySelector('[data-prepnord-compare]');
    const addLabel = root.querySelector('[data-prepnord-add-label]');
    const addButton = root.querySelector('[data-prepnord-add-button]');
    const variantLabel = root.querySelector('[data-prepnord-variant-label]');

    root.querySelectorAll('[data-prepnord-thumb]').forEach((button) => {
      button.addEventListener('click', () => activateThumb(root, button));
    });

    if (!variantSelect) return;

    const syncVariant = () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      if (!option) return;

      const price = option.getAttribute('data-price');
      const compare = option.getAttribute('data-compare');
      const mediaId = option.getAttribute('data-media-id');

      if (priceElement && price) {
        priceElement.textContent = price;
      }

      if (compareElement) {
        if (compare) {
          compareElement.textContent = compare;
          compareElement.hidden = false;
        } else {
          compareElement.textContent = '';
          compareElement.hidden = true;
        }
      }

      if (variantLabel) {
        variantLabel.textContent = option.textContent.trim();
      }

      if (addButton) {
        addButton.disabled = option.disabled;
      }

      if (addLabel) {
        addLabel.textContent = option.disabled ? 'Uitverkocht' : 'Toevoegen aan winkelwagen';
      }

      if (mediaId) {
        const matchingThumb = root.querySelector(`[data-prepnord-thumb][data-media-id="${mediaId}"]`);
        if (matchingThumb) {
          activateThumb(root, matchingThumb);
        }
      }
    };

    variantSelect.addEventListener('change', syncVariant);
    syncVariant();
  });

  const predictiveInstances = [];

  doc.querySelectorAll('[data-prepnord-predictive-search]').forEach((form) => {
    const input = form.querySelector('input[type="search"]');
    const results = form.querySelector('[data-prepnord-predictive-results]');
    const status = form.querySelector('[data-prepnord-predictive-status]');
    if (!input || !results) return;

    let abortController = null;
    let debounceHandle = null;

    const setOpen = (isOpen) => {
      results.hidden = !isOpen;
      input.setAttribute('aria-expanded', String(isOpen));
      form.classList.toggle('is-open', isOpen);
    };

    const close = () => {
      if (abortController) {
        abortController.abort();
        abortController = null;
      }
      setOpen(false);
    };

    const fetchResults = (rawTerm) => {
      const term = rawTerm.trim();
      if (term.length < 2) {
        if (status) status.textContent = '';
        results.innerHTML = '';
        close();
        return;
      }

      if (abortController) {
        abortController.abort();
      }

      abortController = new AbortController();

      const params = new URLSearchParams({
        q: term,
        section_id: 'predictive-search',
        'resources[type]': 'product,collection,page,query',
        'resources[limit]': '4',
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'hide'
      });

      const searchUrl = new URL(
        'search/suggest',
        window.location.origin + (window.Shopify?.routes?.root || '/')
      );
      searchUrl.search = params.toString();

      fetch(searchUrl.toString(), {
        headers: { Accept: 'text/html' },
        signal: abortController.signal
      })
        .then((response) => {
          if (!response.ok) throw new Error('Kon zoeksuggesties niet laden');
          return response.text();
        })
        .then((text) => {
          const documentFragment = new DOMParser().parseFromString(text, 'text/html');
          const section = documentFragment.querySelector('#shopify-section-predictive-search');
          const markup = section ? section.innerHTML.trim() : '';

          results.innerHTML = markup;
          setOpen(Boolean(markup));

          if (status) {
            status.textContent = markup ? '' : '';
          }
        })
        .catch((error) => {
          if (error.name === 'AbortError') return;
          results.innerHTML = '';
          close();
        });
    };

    const queueFetch = () => {
      window.clearTimeout(debounceHandle);
      debounceHandle = window.setTimeout(() => fetchResults(input.value), 220);
    };

    input.addEventListener('input', queueFetch);
    input.addEventListener('focus', () => {
      if (input.value.trim().length >= 2) {
        queueFetch();
      }
    });
    input.addEventListener('blur', () => {
      window.setTimeout(() => {
        const activeElement = doc.activeElement;
        if (activeElement && form.contains(activeElement)) return;
        close();
      }, 120);
    });

    predictiveInstances.push({ form, close });
  });

  const closePredictiveSearches = (exceptForm = null) => {
    predictiveInstances.forEach((instance) => {
      if (instance.form === exceptForm) return;
      instance.close();
    });
  };

  doc.addEventListener('click', (event) => {
    const activeForm = event.target.closest('[data-prepnord-predictive-search]');
    closePredictiveSearches(activeForm);
  });

  doc.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeMenus();
    closeDrawers();
    closePredictiveSearches();
  });

  fetchCart().catch(() => {});
})();
